import { __decorate } from "tslib";
import { Component, Mixins } from "vue-property-decorator";
import TeamOperationsSectionEditMixin from "./TeamOperationsSectionEditMixin";
import TeamOperationsFieldInput from "./TeamOperationsFieldInput.vue";
import TeamOperationsEditFooter from "./TeamOperationsEditFooter.vue";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
/**
 * Add / Edit Tools & Technology Stack: Technology Stack, Tools Stack and Dev Environment side by side.
 * A comma-separated draft previews as the same chips the tab shows.
 */
let TeamOperationsToolsModal = /** @class */ (() => {
    let TeamOperationsToolsModal = class TeamOperationsToolsModal extends Mixins(TeamOperationsSectionEditMixin) {
        draftChips(row, field) {
            const value = this.inputValue(row, field);
            if (value.indexOf(",") === -1) {
                return [];
            }
            return value
                .split(",")
                .map((part) => part.trim())
                .filter((part) => !!part);
        }
    };
    TeamOperationsToolsModal = __decorate([
        Component({
            name: "TeamOperationsToolsModal",
            components: {
                SectionLoader,
                TeamOperationsFieldInput,
                TeamOperationsEditFooter,
            },
        })
    ], TeamOperationsToolsModal);
    return TeamOperationsToolsModal;
})();
export default TeamOperationsToolsModal;
